import React from 'react';

const linksData = [
  {
    category: 'Market News',
    links: [
      { name: 'iinvest', url: 'https://iinvest.cogencis.com/news' },
      { name: 'Zerodha Pulse', url: 'https://pulse.zerodha.com/' },
      { name: 'Economic Times', url: 'https://economictimes.indiatimes.com/' },
      { name: 'CNBC TV18', url: 'https://www.cnbctv18.com/market/' },
      { name: 'Business Standard', url: 'https://www.business-standard.com/markets' },
      { name: 'Moneycontrol', url: 'https://www.moneycontrol.com/news/' },
      { name: 'Trendlyne Results', url: 'https://trendlyne.com/dashboard/results/industry/' },
    ],
  },
  {
    category: 'Startup News',
    links: [
    { name: 'ycombinator news', url: 'https://news.ycombinator.com/' },
    { name: 'Tech Crunch', url: 'https://techcrunch.com/latest/' },
    { name: 'Tech in Asia', url: 'https://www.techinasia.com/' },
    { name: 'VentureBeat', url: 'https://venturebeat.com/' },
    { name: 'Business Insider', url: 'https://www.businessinsider.com/seed-100-best-early-stage-vc-investors-2025-5?utm_source=chatgpt.com' },
    { name: 'thestartupboard', url: 'https://www.thestartupboard.com/blog/10-best-websites-to-find-angel-investors-for-startups?utm_source=chatgpt.com' },
    ],
  },
  {
    category: 'Magazines',
    links: [
      { name: 'Smart Investment', url: 'https://smartinvestment.in/' },
      { name: 'Dalal Street', url: 'https://www.dsij.in/' },
      { name: 'Capital Market', url: 'https://www.capitalmarket.com/news' },
    ],
  },
  {
    category: 'Forums',
    links: [
      { name: 'Value Pickr', url: 'https://forum.valuepickr.com/' },
      { name: 'Trading QnA', url: 'https://tradingqna.com/c/stocks/13' },
      { name: 'Reddit: IndianStocks', url: 'https://www.reddit.com/r/IndianStocks/' },
      { name: 'Reddit: IndianStreetBets', url: 'https://www.reddit.com/r/IndianStreetBets/' },
      { name: 'Reddit: IndiaInvestments', url: 'https://www.reddit.com/r/IndiaInvestments/' },
    ],
  },
  {
    category: 'Research Reports',
    links: [
      { name: 'Dalal Street', url: 'https://www.dsij.in/markets/reports/broker-reports' },
      { name: 'Trendlyne Upgrade', url: 'https://trendlyne.com/research-reports/recent-upgrades/' },
      { name: 'Trendlyne Downgrade', url: 'https://trendlyne.com/research-reports/recent-downgrades/' },
      { name: 'Moneycontrol List', url: 'https://www.moneycontrol.com/markets/stock-ideas/?classic=true' },
      { name: 'Moneycontrol Daily Report', url: 'https://www.moneycontrol.com/markets/brokerage-view.php?c=4' },
    ],
  },
  {
    category: 'YT Channels',
    links: [ 
      { name: 'Markets By Zerodha', url: 'https://www.youtube.com/@marketsbyzerodha' },
      { name: 'In The Money by Zerodha', url: 'https://www.youtube.com/@InTheMoneybyZerodha' },
      { name: 'SOIC', url: 'https://www.youtube.com/@SOICfinance' },
      { name: 'FinnovationZ', url: 'https://www.youtube.com/@namaskarprasad' },
      { name: 'Groww', url: 'https://www.youtube.com/@GrowwOfficial' },
      { name: 'Upstox', url: 'https://www.youtube.com/@UpstoxOfficial' },
      { name: 'ET NOW', url: 'https://www.youtube.com/@ETNOW' },
      { name: 'CNBC-TV18', url: 'https://www.youtube.com/@cnbctv18india' },
      { name: 'NDTV Profit', url: 'https://www.youtube.com/@NDTVProfitIndia' },
      { name: 'Moneycontrol', url: 'https://www.youtube.com/@moneycontrol' },
      { name: 'Kotak Mutual Fund', url: 'https://www.youtube.com/@KotakMahindraMutualFund' },
      { name: 'Ind Money', url: 'https://www.youtube.com/@INDmoney' },
    ],
  },
  {
    category: 'Finance Influencer',
    links: [ 
      { name: 'Rachana Ranade', url: 'https://www.youtube.com/@CARachanaRanade' },
      { name: 'Paisa Smart', url: 'https://www.youtube.com/@paisasmart' },
      { name: 'Sahil Bhadviya', url: 'https://www.youtube.com/@SahilBhadviya' },
      { name: 'Rahul Jain', url: 'https://www.youtube.com/@torahulj' },
      { name: 'Shashank Udupa', url: 'https://www.youtube.com/@ShashankUdupa1' },
      { name: 'Shankar Nath', url: 'https://www.youtube.com/@shankarnath' },
      { name: 'Kushal Lodha', url: 'https://www.youtube.com/@KushalLodha548' },
      { name: 'Shrishti Sahu', url: 'https://www.youtube.com/@TheIndiaOpportunity' },
      { name: 'Sonia Shenoy', url: 'https://www.youtube.com/@soniashenoyofficial' },      
      { name: 'Money Pechu', url: 'https://www.youtube.com/@MoneyPechu' },
      { name: 'Learn Stock Market', url: 'https://www.youtube.com/@Elearnmarkets' },
      { name: 'Exploring Minds', url: 'https://www.youtube.com/@exploringminds_podcast' },
      { name: 'Finance With Sharan', url: 'https://www.youtube.com/@financewithsharan' },
      { name: 'Parimal Ade', url: 'https://www.youtube.com/@ParimalAde' },
      { name: 'Yadnya Investment Academy', url: 'https://www.youtube.com/@InvestYadnya' },
      { name: 'Finance With Sharan', url: 'https://www.youtube.com/@financewithsharan' },
      { name: 'Learning Markets With Manish', url: 'https://www.youtube.com/@LearningMarketsWithManish' },
      { name: 'Rohit Srivastava', url: 'https://www.youtube.com/@indiacharts' },
    ],
  },
  {
    category: 'Scanners',
    links: [
      { name: 'Volume Pump', url: 'https://trendlyne.com/stock-screeners/volume-based/high-volume-stocks/top-gainers/today/' },
      { name: 'Below IPO price', url: 'https://www.screener.in/ipo/below-price/' },
      { name: 'IPO listing Returns', url: 'https://groww.in/ipo/closed' },
      { name: 'NSE Mood Index', url: 'https://www.tickertape.in/market-mood-index?ref=homepage_mmi_section' },
      { name: 'Crypto Mood Index', url: 'https://coinmarketcap.com/charts/fear-and-greed-index/' },
      { name: 'TradeEconomics Commodities', url: 'https://tradingeconomics.com/commodities' },
      { name: 'TJI Raw Material', url: 'https://www.tijorifinance.com/in/raw-materials'},
      { name: 'TJI Chemical', url: 'https://www.tijorifinance.com/sector/chemicals'},
      { name: 'Investing Rule Book', url: 'https://web.archive.org/web/20230602132920/https://www.getpaidindia.com/Equity_Investing_Rules_Book'},
      { name: 'OFFICE OF THE ECONOMIC ADVISER Data', url: 'https://eaindustry.nic.in/default.asp'},
      { name: 'Indian Exports Data', url: 'https://tradestat.commerce.gov.in/eidb/commodity_wise_export'},
      { name: 'Indian Petro Chem', url: 'https://indianpetrochem.com/'},
      { name: 'Bigmint Data', url: 'https://www.bigmint.co/'},
      { name: 'Indian Data Hub', url: 'https://indiadatahub.com/'},
      { name: 'Gov Data', url: 'https://www.data.gov.in/'},
      { name: 'RBI Statistics', url: 'https://rbi.org.in/Scripts/Statistics.aspx'},
      { name: 'Digital Payments in India', url: 'https://digipay.gov.in/'},
      { name: 'US Stocks', url: 'https://www.tradingview.com/screener'},
    ],
  },
  {
    category: 'Scan360',
    links: [
      { name: 'Scan360 Learning', url: '/learning'},
      { name: 'Interviews', url: '/interviews'}
    ],
  },
];

function Resources() {
  return (
    <div className="p-4 mb-6">
      <h2 className="text-2xl font-bold mb-4">Resources</h2>

      {/* Desktop table view */}
      <div className="hidden md:block overflow-x-auto">
        <table className="table-auto border-collapse w-full text-sm">
          <thead className="bg-gray-100">
            <tr>
              {linksData.map((section, idx) => (
                <th key={idx} className="p-2 border text-left">{section.category}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({
              length: Math.max(...linksData.map((s) => s.links.length)),
            }).map((_, rowIdx) => (
              <tr key={rowIdx} className={rowIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                {linksData.map((section, colIdx) => (
                  <td key={colIdx} className="p-2 border">
                    {section.links[rowIdx] ? (
                      <a
                        href={section.links[rowIdx].url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 underline hover:text-blue-800"
                      >
                        {section.links[rowIdx].name}
                      </a>
                    ) : null}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile card/list view */}
      <div className="md:hidden space-y-6">
        {linksData.map((section, idx) => (
          <div key={idx} className="border rounded-lg shadow-sm p-4 bg-white">
            <h3 className="text-lg font-semibold mb-3">{section.category}</h3>
            <ul className="space-y-2">
              {section.links.map((link, linkIdx) => (
                <li key={linkIdx}>
                  <a
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline hover:text-blue-800"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Resources;
